"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var confirmation_modal_content_component_1 = __importDefault(require("../confirmation-modal-content/confirmation-modal-content.component"));

var progress_modal_content_component_1 = __importDefault(require("../progress-modal-content/progress-modal-content.component"));

var TIMEOUT_DURATION_MS = 1000;

var AsyncProgressModalContent = function AsyncProgressModalContent(_ref) {
  var isPending = _ref.isPending,
      isDone = _ref.isDone,
      errorMessage = _ref.errorMessage,
      ProgressIcon = _ref.ProgressIcon,
      successText = _ref.successText,
      progressText = _ref.progressText,
      description = _ref.description,
      cancelText = _ref.cancelText,
      confirmText = _ref.confirmText,
      onCancelClick = _ref.onCancelClick,
      onConfirmClick = _ref.onConfirmClick,
      handleSuccess = _ref.handleSuccess,
      handleClose = _ref.handleClose,
      disableClose = _ref.disableClose,
      enableClose = _ref.enableClose;
  react_1.useEffect(function () {
    if (isPending) disableClose();
    if (errorMessage || isDone) enableClose();
  }, [isPending, isDone, errorMessage, disableClose, enableClose]);
  react_1.useEffect(function () {
    if (!isDone) return;
    var timeoutId = setTimeout(function () {
      handleSuccess ? handleSuccess() : handleClose();
    }, TIMEOUT_DURATION_MS);
    return function () {
      clearTimeout(timeoutId);
    };
  }, [isDone, handleClose, handleSuccess]);
  return react_1.default.createElement(react_1.default.Fragment, null, isPending || isDone ? react_1.default.createElement(progress_modal_content_component_1.default, {
    ProgressIcon: ProgressIcon,
    successText: successText,
    progressText: progressText,
    isPending: isPending,
    isDone: isDone
  }) : react_1.default.createElement(confirmation_modal_content_component_1.default, {
    description: description,
    cancelText: cancelText,
    confirmText: confirmText,
    onCancelClick: onCancelClick || handleClose,
    onConfirmClick: onConfirmClick,
    errorMessage: errorMessage
  }));
};

exports.default = AsyncProgressModalContent;